import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { IntranetSearchService } from '../../../services/common/intranet-search.service';

@Component({
  selector: 'app-intranet-search',
  templateUrl: './intranet-search.component.html',
  styleUrls: ['./intranet-search.component.css'],
})
export class IntranetSearchComponent implements OnInit {
  intranetSearchTerm: string;

  @Input() include_item: boolean = false;
  @Input() intranetId: number | undefined;
  @Input() small_input: boolean;
  @Input() editable: boolean = true;
  @Input() placeholder: string;
  @Output() intranet_id: EventEmitter<string> = new EventEmitter();
  @Input() select_only: boolean = false;
  @Output() intranet: EventEmitter<any> = new EventEmitter();
  @Output() clearIntranet: EventEmitter<any> = new EventEmitter();

  constructor(private intranetSearchService: IntranetSearchService) {}

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (changes.intranetId && changes.intranetId.currentValue)
      this.intranetSearchService.getIntranetInfo(this.intranetId!).then((response_json) => {
        this.intranetSearchTerm = response_json.name;
      });
    else if (this.select_only) this.intranetSearchTerm = '';
  }

  clearSelectedIntranet(): void {
    this.intranetId = undefined;
    this.intranetSearchTerm = '';
    this.clearIntranet.emit('clearIntranet');
  }

  intranetSearchOnSelect(item: any): void {
    if (this.include_item) this.intranetId = item.id;
    else this.intranetId = item;
    if (this.select_only) {
      let scope = this;
      this.intranet.emit(item);
      window.setTimeout(function () {
        scope.intranetSearchTerm = '';
      }, 100);
    } else if (this.include_item) {
      this.intranet.emit(item);
      this.intranet_id.emit(String(item.id));
    } else this.intranet_id.emit(String(item));
  }
}
